/**Dependencies */
import React from 'react'

/**Components */
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

/**Styles */
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '../styles/home.scss';


/**Images */

export const Carousel3D = ({imgsArr}) => {
  return (
    <div className='swiper d-flex justify-content-center align-items-center p-0 p-sm-5 p-lg-5'>
     
        <Swiper
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            loop={false}
            initialSlide={1}
            slidesPerView={1}
            coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 200,
            modifier: 1.5,
            }}
            /* pagination={{ el: '.swiper-pagination', clickable: true }} */
            navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            clickable: true,
            }}
            breakpoints={{                 
                320: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },                
                480: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },                
                640: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }}
            modules={[EffectCoverflow, Pagination, Navigation]}
            className="swiper_container_3D"
        >

            {imgsArr.map((infoImg, index)=>(            
                <SwiperSlide key={index + 1} className='slide-3D'>
                    <div className='image-container'>
                        <img src={infoImg.img} alt="slide_image" />
                    </div>
                    
                </SwiperSlide>
            ))}            
            <div className="slider-controler">
                <div className="swiper-button-prev slider-arrow">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </div>
                <div className="swiper-button-next slider-arrow">
                    <ion-icon name="arrow-forward-outline"></ion-icon>
                </div>
                <div className="swiper-pagination"></div>
            </div>
        </Swiper>
    </div>
  )
}
